<div class="go-back">
	<a href="javascript:void(0);" (click)="onCancel()">
		<i class="fa fa-arrow-left"></i>
		<h6 class="text-uppercase">comments and stips</h6>
	</a>
</div>
<div class="wrapper view-comments">
	<cv-tab-group>
		<cv-tab [title]="'Comments'"
						[active]="viewMode === VIEW_COMMENTS_MODE.COMMENTS"
						(tabActivated)="toggleViewMode()">
			<div class="comment" *ngFor="let comment of comments; let index = index">
				<cv-rule-comment-stip-view-item-component
					*ngIf="viewMode === VIEW_COMMENTS_MODE.COMMENTS"
					[item]="comment"
					[index]="index"
					[viewMode]="VIEW_COMMENTS_MODE.COMMENTS"
					(selected)="onItemSelected($event)">
				</cv-rule-comment-stip-view-item-component>
			</div>
		</cv-tab>
		<cv-tab [title]="'Stips'"
						[active]="viewMode === VIEW_COMMENTS_MODE.STIPS"
						(tabActivated)="toggleViewMode()">
			<div class="comment" *ngFor="let stip of stips; let index = index">
				<cv-rule-comment-stip-view-item-component
					*ngIf="viewMode === VIEW_COMMENTS_MODE.STIPS"
					[item]="stip"
					[index]="index"
					[viewMode]="VIEW_COMMENTS_MODE.STIPS"
					(selected)="onItemSelected($event)">
				</cv-rule-comment-stip-view-item-component>
			</div>
		</cv-tab>
	</cv-tab-group>
</div>
<div class="footer" *ngIf="!disableAdd">
	<button type="button"
					class="btn btn-link"
					[disabled]="!canAddStips()"
					(click)="onAdd()">
		<i class="fas fa-plus-circle"></i> Add {{viewMode === VIEW_COMMENTS_MODE.COMMENTS ? 'Comment' : 'Stip'}}
	</button>
	<button type="button" class="btn btn-link"
					(click)="onDelete()" [disabled]="!selectedItems.length">
		<i class="fas fa-times-circle"></i> Delete {{selectedItems.length ? selectedItems.length : ''}} {{viewMode === VIEW_COMMENTS_MODE.COMMENTS ? 'Comment' : 'Stip'}}{{selectedItems.length === 0 || selectedItems.length > 1 ? 's' : ''}}
	</button>
</div>
